import React from 'react';
import { useCovideoTheme } from 'react-covideo-common';
import { theme } from './style';

export const IconSparkleGradient = () => {
  const covideoTheme = useCovideoTheme();
  const startColor = theme.palette.magic100;
  const endColor = covideoTheme.colors.primary[100];
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2169 6.66666L16.8752 5.20833L18.3335 4.55C18.6585 4.4 18.6585 3.94166 18.3335 3.79166L16.8752 3.13333L16.2169 1.66666C16.0669 1.34166 15.6085 1.34166 15.4585 1.66666L14.8002 3.125L13.3335 3.78333C13.0085 3.93333 13.0085 4.39166 13.3335 4.54166L14.7919 5.2L15.4502 6.66666C15.6002 6.99166 16.0669 6.99166 16.2169 6.66666ZM9.58353 7.91666L8.25853 5C7.96686 4.35 7.03353 4.35 6.74186 5L5.41686 7.91666L2.5002 9.24166C1.8502 9.54166 1.8502 10.4667 2.5002 10.7583L5.41686 12.0833L6.74186 15C7.04186 15.65 7.96686 15.65 8.25853 15L9.58353 12.0833L12.5002 10.7583C13.1502 10.4583 13.1502 9.53333 12.5002 9.24166L9.58353 7.91666ZM15.4502 13.3333L14.7919 14.7917L13.3335 15.45C13.0085 15.6 13.0085 16.0583 13.3335 16.2083L14.7919 16.8667L15.4502 18.3333C15.6002 18.6583 16.0585 18.6583 16.2085 18.3333L16.8669 16.875L18.3335 16.2167C18.6585 16.0667 18.6585 15.6083 18.3335 15.4583L16.8752 14.8L16.2169 13.3333C16.0669 13.0083 15.6002 13.0083 15.4502 13.3333Z"
        fill="url(#paint0_linear_15110_1333)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15110_1333"
          x1="5.11856"
          y1="18.5771"
          x2="19.5969"
          y2="12.8001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};
